import '../landing.css';

const Header = () => {
    return (
        <header id="masthead" className="site-header fixed-top shadow-sm" role="banner">
            <div className="container-fluid" style={{ minHeight: '70px', lineHeight: '70px' }}>
                <div className="row">
                    <div className="col-auto" style={{ textAlign: 'center', width: '100px' }}>
                        <a href="#" style={{ display: 'block' }}>
                            <img src="WSWC_logo-white-v2.png" style={{ height: '40px', margin: '0 auto' }} alt="WATERSKI CANADA" />
                        </a>
                    </div>
                    <div className="col">
                        <div className="float-right">
                            <a title="Login" href="/login">
                                Login
                            </a>
                            &nbsp;&nbsp;|&nbsp;&nbsp;
                            <a title="Join" href="/join">
                                Join
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
